'use client';

import {AboutUs} from './components/about-us/about-us';
import {ComingSoon} from './components/coming-soon/coming-soon';
import {FeaturedCourses} from './components/featured-courses/featured-courses';
import {Footer} from './components/footer/footer';
import {Hero} from './components/hero/hero-section';
import {InteractiveFeatures} from './components/interactive-features/interactive-features';
import {WhySection} from './components/why-section/why-section';

import './page.scss';
import styles from './page.module.scss';

import {TrackingContextProvider} from '@udemy-v2/event-tracking';
import {useEffect} from 'react';
import assetLoader from '@/utils/asset-loader';
import ReactDOM from 'react-dom';

const LandingPage: React.FC = () => {
    useEffect(() => {
        ReactDOM.preload(assetLoader({src: '/fonts/UdemySansWeb-Light.woff2'}), {
            as: 'font',
            crossOrigin: 'anonymous',
        });
        ReactDOM.preload(assetLoader({src: '/fonts/UdemySansWeb-Medium.woff2'}), {
            as: 'font',
            crossOrigin: 'anonymous',
        });
    }, []);

    return (
        <TrackingContextProvider autoInitialize={true}>
            <main className={styles.mainContainer}>
                <div className={styles.contentWrapper}>
                    <Hero />
                    <AboutUs />
                    <InteractiveFeatures />
                    <WhySection />
                    <FeaturedCourses />
                    <ComingSoon />
                    <Footer />
                </div>
            </main>
        </TrackingContextProvider>
    );
};

export {LandingPage};
